const FIELD = "returns_return_shipment[return_items_attributes][]";

// A reason can pull in a second, narrower select (which description was wrong,
// which kind of defect). Picking "other" there, or a reason flagged as needing
// detail, opens the free-text box.
export default function ItemRow({
  item,
  index,
  orderId,
  selected,
  state,
  reasons,
  extraOptionsFor,
  labels,
  onToggle,
  onChange,
}) {
  if (item.returnState) {
    return (
      <tr>
        <td>{index}. </td>
        <td>
          {item.articleNo}
          <p>{item.description}</p>
        </td>
        <td>{item.price}</td>
        <td className="returnReasonColumn">
          {item.existingReason}
          {item.existingDetail}
        </td>
      </tr>
    );
  }

  const reason = reasons.find((r) => String(r.id) === String(state.reasonId));
  const extraOptions = extraOptionsFor(state.reasonId);
  const showDetail = Boolean(reason?.detailReason) || state.extraReason.endsWith(".other");

  return (
    <tr id={`item_${item.id}`}>
      <td>
        <div className="gr-12 checkbox-wrapper gr-9@mobile prefix-1@mobile suffix-2@mobile">
          {index}.{" "}
          <input
            type="checkbox"
            className="checkbox"
            id={`check_item_${item.id}`}
            checked={selected}
            onChange={(e) => onToggle(e.target.checked)}
          />
          <label htmlFor={`check_item_${item.id}`}>
            <span className="checkbox" />
          </label>
        </div>
      </td>
      <td>
        {item.articleNo}
        <p>{item.description}</p>
      </td>
      <td className="priceColumn">{item.price}</td>
      <td>
        {/* Only selected rows submit fields, which is what the disabled
            attributes were doing before. */}
        {selected && <input type="hidden" name={`${FIELD}[order_id]`} value={orderId} />}
        {selected && <input type="hidden" name={`${FIELD}[order_line_item_id]`} value={item.id} />}
        <select
          className={`return${state.invalid ? " error" : ""}`}
          id={`returnreason_${item.id}`}
          name={selected ? `${FIELD}[return_reason_id]` : undefined}
          value={state.reasonId}
          disabled={!selected}
          style={{ display: selected ? "" : "none" }}
          onChange={(e) => onChange({ reasonId: e.target.value, extraReason: "", detail: "" })}
        >
          <option value="">{labels.select}</option>
          {reasons.map((r) => (
            <option key={r.id} value={r.id}>
              {r.description}
            </option>
          ))}
        </select>

        <div className="extra_reasons">
          {selected && extraOptions.length > 0 && (
            <select
              className="extra_reason_select"
              name={`${FIELD}[extra_reason]`}
              value={state.extraReason}
              onChange={(e) => onChange({ extraReason: e.target.value, detail: "" })}
            >
              <option value="">{labels.select}</option>
              {extraOptions.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>
          )}
        </div>

        {selected && showDetail && (
          <input
            type="text"
            className="detail_return form-control"
            id={`detail_return_${item.id}`}
            name={`${FIELD}[return_detail_reason]`}
            placeholder={labels.detailReason}
            maxLength={50}
            value={state.detail}
            onChange={(e) => onChange({ detail: e.target.value })}
          />
        )}
      </td>
    </tr>
  );
}
